// extracted by mini-css-extract-plugin
export default {"backToTop":"backtottop_backToTop__vwDLo","icon":"backtottop_icon__1J8RS"};